import { Button, InputItem, List, TextareaItem, Toast } from "antd-mobile";
import React, { useState } from "react";
import DictionarySelect from "../../../component/CheckBoxItem";
import instance, { messageResponse } from "../../../util/axios";
import ImageItem from "../../../component/ImageItem";

const defaultData = {
  orderNumber: "",
  radId: "",
  model: "",
  color: "",
  caliber: "",
  procedureId: "",
  workshopId: "",
  managerId: "",
  totalCount: "",
  count: "",
  problemType: "",
  reason: "",
  attachmentIds: "",
};

export default function QAReject() {
  const [data, setData] = useState<{
    orderNumber: string;
    radId?: string;
    model?: string;
    color?: string;
    caliber?: string;
    procedureId?: string;
    workshopId?: string;
    managerId?: string;
    totalCount?: string;
    count?: string;
    problemType?: string;
    reason?: string;
    attachmentIds?: string;
  }>(defaultData);

  return (
    <>
      <List>
        <InputItem
          type={"text"}
          style={{ textAlign: "left" }}
          value={data.orderNumber}
          onChange={(value) =>
            setData((prevState) => ({
              ...prevState,
              orderNumber: value,
            }))
          }
        >
          订单号
        </InputItem>
        <DictionarySelect
          title={"货品名称"}
          multiple={false}
          dictionary={"rad_sku"}
          value={data.radId}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              radId: value,
            }));
          }}
        />
        <InputItem
              type={"text"}
              style={{ textAlign: "left" }}
              value={data.model}
              onChange={(value) =>
                  setData((prevState) => ({
                      ...prevState,
                      model: value,
                  }))
              }
          >
           规格
        </InputItem>
        <DictionarySelect
          title={"表面处理"}
          multiple={false}
          dictionary={"dict_rad_color"}
          value={data.color}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              color: value,
            }));
          }}
        />
        <DictionarySelect
          title={"口径"}
          multiple={false}
          dictionary={"dict_rad_caliber"}
          value={data.caliber}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              caliber: value,
            }));
          }}
        />
        <DictionarySelect
          title={"车间"}
          multiple={false}
          dictionary={"erp_workshop"}
          value={data.workshopId}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              workshopId: value,
            }));
          }}
        />
        <DictionarySelect
          title={"工序"}
          multiple={false}
          dictionary={"erp_procedure"}
          value={data.procedureId}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              procedureId: value,
            }));
          }}
        />
        <DictionarySelect
          title={"车间主管"}
          multiple={false}
          dictionary={"base_staff"}
          value={data.managerId}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              managerId: value,
            }));
          }}
        />
        <InputItem
          type={"number"}
          value={data.totalCount}
          style={{ textAlign: "left" }}
          onChange={(value) =>
            setData((prevState) => ({
              ...prevState,
              totalCount: value,
            }))
          }
        >
          抽检数量
        </InputItem>
        <InputItem
          type={"number"}
          value={data.count}
          style={{ textAlign: "left" }}
          onChange={(value) =>
            setData((prevState) => ({
              ...prevState,
              count: value,
            }))
          }
        >
          不良数量
        </InputItem>
        <DictionarySelect
          title={"原材料问题"}
          multiple={false}
          dictionary={"dict_order_free_bool"}
          value={data.problemType}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              problemType: value,
            }));
          }}
        />
        <TextareaItem
          title={"原因描述"}
          autoHeight={true}
          value={data.reason}
          onChange={(value) =>
            setData((prevState) => ({
              ...prevState,
              reason: value,
            }))
          }
        />
        <ImageItem
          disabled={false}
          dictionary={""}
          value={data.attachmentIds}
          placeholder={"照片"}
          width={"400px"}
          onChange={(value) => {
            setData((prevState) => ({
              ...prevState,
              attachmentIds: value,
            }));
          }}
        />
        <List.Item>
          <Button
            type={"primary"}
            onClick={() => {
              if (!data.totalCount) {
                Toast.fail("请填写抽检数量！");
                return;
              }
              if (!data.count) {
                Toast.fail("请填写不良数量！");
                return;
              }
              if (!data.reason && data.problemType !== "1") {
                Toast.fail("请填写原因描述！");
                return;
              }
              if (!data.attachmentIds) {
                Toast.fail("请上传图片！");
                return;
              }
              instance
                .post(`/erp/production-tasks/insertReject`, data)
                .then((resp) => {
                  messageResponse(resp, () => {
                    setData(defaultData);
                  });
                });
            }}
          >
            打回
          </Button>
        </List.Item>
      </List>
    </>
  );
}
